import React from 'react'

import { EditableText } from '@sketch/components'

import { MarkdownDocumentDescription } from './MarkdownDocumentDescription'
import { DocumentDescriptionWrapper } from './EditableDocumentDescription.styles'

export interface EditableDocumentDescriptionProps {
  description?: string
  editHandler?: (description: string) => void
  placeholder?: string
  className?: string
  hideIcon?: boolean // if true, the pencil icon will not be displayed
}

export const EditableDocumentDescription: React.FC<
  EditableDocumentDescriptionProps
> = ({
  description,
  editHandler,
  placeholder = 'Enter a description…',
  className,
  hideIcon,
}) => {
  return (
    <DocumentDescriptionWrapper
      className={className}
      data-testid="document-description"
    >
      {editHandler ? (
        <EditableText
          element={MarkdownDocumentDescription}
          value={description}
          placeholder={placeholder}
          onEdit={editHandler}
          hideIcon={hideIcon}
          allowNewLines
        />
      ) : (
        <MarkdownDocumentDescription>{description}</MarkdownDocumentDescription>
      )}
    </DocumentDescriptionWrapper>
  )
}
